export enum FeedbackType {
  BUG = 'bug',
  GENERAL = 'general',
  ROOM_FEEDBACK = 'rooms',
  OTHER = 'other',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  THREAT_HUNTING_SIM = 'thsim',
}
